import React, {useState} from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';

import DriverSearchInput from "../DriverSearchInput";
import DriversTable from './DriversTable';

function DriversTab() {
    const [searchValue, setSearchValue] = useState("");
    
    const updateSearchValue = (value) => {
      setSearchValue(value);
    }


  return (
    <div>
      <Container maxWidth={false}>
        
        <DriversTable searchInput={searchValue} updateSearchValue={updateSearchValue} />
      </Container>
    </div>
  );
}

export default DriversTab;
